import { define, type } from 'type-r';
import Collection, {Record} from './base'

@define
export class ProductCollection<R extends Product = Product> extends Collection<R> {
}

@define
export default class Product extends Record {
    static idAttribute = "pid";    
    static Collection = ProductCollection<Product>;
    
    @type(String).value("0").as pid: string
    @type(String).value("").as title: string
    @type(String).value("").as description: string
    @type(String).value("").as thumbnail: string
    @type(Number).value(0.0).as price: number
    @type(Boolean).value(false).as active: boolean
    @type(Boolean).value(false).as default: boolean
}

